// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"427":"b92d6a5b","484":"f7c7577d","530":"2415ff16","602":"0afd1832","827":"57f18d02","838":"0ce34892"}[chunkId] + ".chunk.css";
};